// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table img {\n    width:-moz-fit-content;\n    width:fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}", "",{"version":3,"sources":["webpack://src/components/Admin/Questions/QuestionStyles.css"],"names":[],"mappings":"AAAA;IACI,sBAAiB;IAAjB,iBAAiB;IACjB,wBAAmB;IAAnB,mBAAmB;AACvB","sourcesContent":["table img {\n    width:fit-content;\n    height: fit-content;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
